var bannerSlider = document.querySelectorAll(
  ".wp-block-fseblocks-banner-slider .banner-swiper"
);

for (i = 0; i < bannerSlider.length; i++) {
  bannerSlider[i].classList.add("slide-" + i);

  const isClickable = jQuery(".banner-swiper.slide-" + i).data("clickable");
  const isAutoPlay = jQuery(".banner-swiper.slide-" + i).data("auto");
  const speed = jQuery(".banner-swiper.slide-" + i).data("speed");
  const perView = jQuery(".banner-swiper.slide-" + i).data("perview");
  const space = jQuery(".banner-swiper.slide-" + i).data("space");
  const smallPerView = jQuery(".banner-swiper.slide-" + i).data("smallperview");
  const smallspace = jQuery(".banner-swiper.slide-" + i).data("smallspace");
  const mediumPerView = jQuery(".banner-swiper.slide-" + i).data(
    "mediumperview"
  );
  const mediumspace = jQuery(".banner-swiper.slide-" + i).data("mediumspace");
  const effect = jQuery(".banner-swiper.slide-" + i).data("effect");
  const autocentre = jQuery(".banner-swiper.slide-" + i).data("autocentre");
  const paginationType = jQuery(".banner-swiper.slide-" + i).data(
    "paginationtype"
  );
  const showNavigation = jQuery(".banner-swiper.slide-" + i).data(
    "shownavigation"
  );

  var swiperOptions = {
    loop: true,
    lazy: false,
    effect: effect,
    centeredSlides: autocentre,
    spaceBetween: perView === 1 ? 0 : space,
    slidesPerView: perView ? perView : 1,
    autoplay:
      isAutoPlay === true
        ? {
            delay: parseInt(speed * 1000),
          }
        : false,
    pagination: {
      el: `.banner-swiper.slide-${i} .swiper-pagination`,
      clickable: isClickable,
      type: paginationType,
    },
    navigation: {
      nextEl: `.banner-swiper.slide-${i} + .fseblocks-swiper-nav .swiper-button-next`,
      prevEl: `.banner-swiper.slide-${i} + .fseblocks-swiper-nav .swiper-button-prev`,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: smallPerView ? smallPerView : 1,
        spaceBetween: smallPerView === 1 ? 0 : smallspace,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: mediumPerView ? mediumPerView : 2,
        spaceBetween: mediumPerView === 1 ? 0 : mediumspace,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: perView ? perView : 1,
        spaceBetween: perView === 1 ? 0 : space,
      },
    },
  };

  // Conditionally add fade effect configuration
  if (effect === "fade") {
    swiperOptions.fadeEffect = { crossFade: true };
  }

  var swiper = new Swiper(".banner-swiper.slide-" + i, swiperOptions);
}
